'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'bug';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = ['M128 264l0 24 0 32c0 65.3 48.9 119.1 112 127l0-191c0-8.8 7.2-16 16-16s16 7.2 16 16l0 191c63.1-7.9 112-61.7 112-127l0-32 0-24c0-39.8-32.2-72-72-72l-112 0c-39.8 0-72 32.2-72 72zM192 96l128 0c0-35.3-28.7-64-64-64s-64 28.7-64 64z', 'M256 32c-35.3 0-64 28.7-64 64l128 0c0-35.3-28.7-64-64-64zM160 96c0-53 43-96 96-96s96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6zM36.7 100.7c6.2-6.2 16.4-6.2 22.6 0L138.6 180c17.2-12.6 38.4-20 61.4-20l112 0c22.9 0 44.2 7.4 61.4 20l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L396 202.6c12.6 17.2 20 38.4 20 61.4l0 8 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 16c0 30.2-8.4 58.4-22.9 82.5l82.2 82.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79-79C344.5 460.1 302.6 480 256 480s-88.5-19.9-117.7-51.6l-79 79c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l82.2-82.2C104.4 378.4 96 350.2 96 320l0-16-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-8c0-22.9 7.4-44.2 20-61.4L36.7 123.3c-6.2-6.2-6.2-16.4 0-22.6zM128 320c0 65.3 48.9 119.1 112 127l0-191c0-8.8 7.2-16 16-16s16 7.2 16 16l0 191c63.1-7.9 112-61.7 112-127l0-32 0-24c0-39.8-32.2-72-72-72l-112 0c-39.8 0-72 32.2-72 72l0 24 0 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;